import { createApp } from 'vue'

(function () {
  const appContainerSelector = '.contact-person-search .vue-app'

  console.log('start')
  if (!document.querySelector(appContainerSelector)) {
    return
  }

  createApp({
    data () {
      return {
        query: '',
        contactPersons: window.contactPersonListJson,
        querySubmitted: false,
        foundContact: null
      }
    },
    methods: {
      onQueryChanged (e) {
        this.hideResult()
        if (this.query && this.query.length > 0) {
          // only allow digits
          this.query = this.query.replaceAll(/([^0-9+\s{1}])/g, '')
        }
      },
      focusQueryInput () {
        this.$refs.queryInput.focus()
      },
      getNumber (person) {
        return '0521 5228-' + person.phoneExtension
      },
      showResult () {
        if (!this.query || this.query.length === 0) {
          window.alert('Bitte geben Sie eine gültige Betriebsnummer ein.')
          return
        }

        if (Number.isInteger(this.query)) {
          this.foundContact = this.contactPersons.find((person) => parseInt(person.bnrStart) <= this.query && this.query <= parseInt(person.bnrEnd))
        }

        this.querySubmitted = true
      },
      hideResult () {
        this.foundContact = null
        this.querySubmitted = false
      }
    },
    template: `
        <form class="contact-person-search__form" @submit.prevent="showResult">
            <label class="form__label" @click="focusQueryInput">Betriebsnummer</label>
            <div class="form__input-block">
                <input class="form__input"
                    ref="queryInput"
                    inputmode="numeric"
                    placeholder="Geben Sie hier Ihre Betriebsnummer ein."
                    type="text"
                    v-model.number="query"
                    @input="onQueryChanged"
                    @change="onQueryChanged"
                />
                <button type="submit" class="btn btn--secondary">Senden</button>
            </div>
        </form>
        
        <div ref="resultContainer" class="contact-person-search__output">
        
            <Transition name="contact-person-search">
              <div v-if="querySubmitted && foundContact" class="contact-person-search__results">
                <div class="contact-person-search__item contact-person-search__item--title">
                  <div>Name</div>
                  <div>Telefonnummer</div>
                </div>
                <div class="contact-person-search__item">
                  <div>{{foundContact.name}}</div>
                  <div>
                    <a :href="'tel:'+getNumber(foundContact)"
                        :title="foundContact.name + ' unter der folgenden Nummer anrufen: ' + getNumber(foundContact)">
                        {{getNumber(foundContact)}}
                    </a>
                  </div>
                </div>
              </div>
            </Transition>
            
            <Transition name="contact-person-search">
              <p v-if="querySubmitted && !foundContact" class="contact-person-search__error">
                  Zu der Betriebsnummer&nbsp;<em>{{query}}</em>&nbsp;konnte kein Ansprechpartner gefunden werden.
              </p>
            </Transition>
            
        </div>
        `
  }).mount(appContainerSelector)
})()
